import script from "./RolesResponsibilitiesCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./RolesResponsibilitiesCompleted.vue?vue&type=script&setup=true&lang=js"

import "./RolesResponsibilitiesCompleted.vue?vue&type=style&index=0&id=58992edf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58992edf"]])

export default __exports__